module.exports = __webpack_public_path__ + "images/emoji/anchor.5387f0a04371b1ec48ff.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/anchor.png
// module id = ufEm
// module chunks = 2